import React from 'react'
import { parse } from 'json2csv'
import DownloadLink from 'react-download-link'
import moment from 'moment'

const CSVDownloader = ({
    records = [],
    columns = [],
    name = 'DSHA Report'
}) => {
    if (!records || !records.length) {
        return null
    }
    return (
        <DownloadLink
            disabled={true}
            label="Export CSV"
            filename={`${name} ${moment().format('YYYY-MM-DD HH-mm-ss')}.csv`}
            exportFile={() => parse(records, { fields: columns.map(c => c.toString()) })}
        />
    )
}

export default CSVDownloader